import axios from "axios";
import qs from "querystring";

const url = process.env.REACT_APP_SERVER_URL;

export const getUserByPhone = (storeId, phone, campaignId, session) => {
  return axios.get(url + "/api/form/user", {
    params: {
      storeId,
      phone,
      session,
      campaignId,
    },
  });
};

export const bookAppointment = (storeId, phone, email, firstName, lastName, date, optedIn, pickup, serviceType, campaignId, session, notes) => {
  return axios.post(
    url + "/api/form/appointment",
    qs.stringify({
      storeId,
      phone,
      email,
      firstName,
      lastName,
      dateTime: date.toLocaleString("en-US"),
      optedIn,
      pickup,
      serviceType,
      campaignId,
      session,
      notes,
    }),
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
};
